import Navigation from "@/components/Navigation";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Helmet } from "react-helmet";

const HoroscopoCaballo = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Horóscopo Chino Caballo - Predicciones Diarias | Dstino</title>
        <meta name="description" content="Horóscopo chino del signo Caballo. Predicciones diarias de amor, trabajo y salud para los nacidos en los años del Caballo." />
      </Helmet>
      
      <Navigation />
      
      <main className="container mx-auto px-4 pt-24 pb-12">
        <Card className="max-w-4xl mx-auto">
          <CardContent className="p-8">
            <div className="text-center mb-6">
              <div className="text-7xl mb-4">🐎</div>
              <h1 className="text-3xl font-bold mb-2">Caballo</h1>
              <p className="text-muted-foreground">Años: 1930, 1942, 1954, 1966, 1978, 1990, 2002, 2014, 2026</p>
            </div>

            <Tabs defaultValue="hoy" className="w-full">
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="hoy">Hoy</TabsTrigger>
                <TabsTrigger value="manana">Mañana</TabsTrigger>
                <TabsTrigger value="semana">Esta Semana</TabsTrigger>
              </TabsList>

              <TabsContent value="hoy" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu espíritu libre y entusiasta atrae admiración hoy, Caballo. Tu autenticidad y alegría contagiosa harán que otros se sientan atraídos hacia ti. Las parejas disfrutarán de aventuras espontáneas juntos.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu energía inagotable te impulsará a completar múltiples tareas hoy. Tu independencia y capacidad de trabajar bajo presión serán reconocidas. Es momento de tomar iniciativa en proyectos nuevos.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu vitalidad natural está en su mejor momento. Actividades al aire libre o deportes te revitalizarán. Tu necesidad de movimiento y libertad es esencial para tu bienestar.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="manana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mañana será perfecto para planes espontáneos con tu pareja. Tu naturaleza aventurera creará momentos memorables. Los solteros podrían conocer a alguien durante una actividad emocionante.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Nuevas oportunidades que requieren valentía y rapidez se presentarán. Tu capacidad de adaptarte rápidamente a cambios te dará ventaja. Confía en tu instinto emprendedor.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu energía estará excelente. Aprovecha para actividades físicas intensas o deportes competitivos. Tu cuerpo responde bien al ejercicio vigoroso y al aire libre.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="semana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Una semana llena de emoción y romance te espera. Tu carisma natural atraerá situaciones amorosas interesantes. Las parejas disfrutarán explorando nuevas experiencias juntos.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Esta semana tu dinamismo será tu mayor fortaleza. Proyectos que requieren acción rápida y decisiones valientes prosperarán bajo tu liderazgo. Tu independencia será valorada.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mantén tu energía equilibrada con actividad física regular. Tu naturaleza inquieta necesita movimiento constante, pero también momentos de descanso para recargar completamente.
                  </p>
                </div>
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default HoroscopoCaballo;
